import { Card, CardBody } from '@windmill/react-ui';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import DepartmentContact from "pages/DepartmentContact"
import {
  FiCodepen,
  FiFile,
  FiBookOpen,
  FiUsers,
  FiArchive,
  FiAperture,
  FiCompass,
  FiSlack,
  FiPackage,
} from 'react-icons/fi';

const icons = {
  'FiUsers': <FiUsers />,
  'FiFile': <FiFile />,
  'FiCodepen': <FiCodepen />,
  'FiArchive':<FiArchive />,
  'FiBookOpen':<FiBookOpen />, 
  'FiAperture':<FiAperture />,
  'FiSlack':<FiSlack />,
  'FiCompass':<FiCompass />,
  'FiPackage':<FiPackage />
};

// import {
//   FiLayout,
//   FiTruck,
//   FiBookOpen,
//   FiCheck,
//   FiRefreshCw,
//   FiAperture,
//   FiServer,
//   FiTrello,
//   FiGrid,
// } from 'react-icons/fi';

// const icons = {
//   'FiCheck': <FiCheck />,
//   'FiTruck': <FiTruck />,
//   'FiLayout': <FiLayout />,
//   'FiRefreshCw':<FiRefreshCw />,
//   'FiBookOpen':<FiBookOpen />, 
//   'FiAperture':<FiAperture />,
//   'FiTrello':<FiTrello />,
//   'FiServer':<FiServer />,
//   'FiGrid':<FiGrid />
// };

const CardItemTwo = ({
  mode,
  title2,
  icon,
  className,
  price,
  currency,
  cash,
  card,
  credit,
  loading,
  bgColor,
  fontSize,
}) => {
  const { t } = useTranslation();

  return (
    <Card className={`flex justify-center h-full`}>
      <CardBody
        className={`border border-gray-200 justify-between dark:border-gray-800 w-full p-6 rounded-lg ${className}`}
        style={{ backgroundColor: bgColor }}
      >
        <div className={`text-center xl:mb-0 mb-3`}>
          {loading ? 
            <Skeleton count={1} width={30} height={30} className="dark:bg-gray-800 bg-gray-200" />
           : 
         
                       <div
                          className={`text-center inline-block text-3xl ${className}`}
                        >
                {icons[icon]} 
              </div>
          }
    
        <div>
          <p className="mb-3 text-base font-medium text-gray-50 dark:text-gray-100">
            {loading ? (
              <Skeleton count={1} height={20} className="dark:bg-gray-800 bg-gray-200" />
            ) : (
              t(`${title2}`)
            )}
          </p>
          <p className="text-2xl font-bold leading-none text-gray-50 dark:text-gray-50" style={{ fontSize: '3rem' }}>
            {loading ? (
              <Skeleton count={1} width={100} height={30} className="dark:bg-gray-800 bg-gray-200" />
            ) : (
              <h2 style={{ fontSize: '2rem' }}>{price}</h2>
            )}
          </p>
        </div>
        

{/*         
        <div className="flex text-center items-center justify-center  text-xs font-normal text-gray-50 dark:text-gray-100">
                    <div className="px-1 mt-3">
                      {t("in_progress")} : 
                      {cash}
                    </div>
                    <div className="px-1 mt-3">
                      {t("Completed")} :
                      {card}
                    </div>
                    <div className="px-1 mt-3">
                      {t("Canceled")} :
                      {credit}
                    </div>
                  </div> */}
                  </div>
      </CardBody>

    </Card>
    // <>
    //   {loading ? (
    //     <Skeleton
    //       count={4}
    //       height={40}
    //       className="dark:bg-gray-800 bg-gray-200"
    //       baseColor={`${mode === "dark" ? "#010101" : "#f9f9f9"}`}
    //       highlightColor={`${mode === "dark" ? "#1a1c23" : "#f8f8f8"} `}
    //     />
    //   ) : (
    //     <>
    //       {title2 === "Today Order" || title2 === "Yesterday Order" ? (
    //         <Card className={`flex justify-center h-full`}>
    //           <CardBody
    //             className={`border border-gray-200 justify-between dark:border-gray-800 w-full p-6 rounded-lg ${className}`}
    //           >
    //             <div className="text-center xl:mb-0 mb-3">
    //               <div
    //                 className={`text-center inline-block text-3xl ${className}`}
    //               >
    //                 <Icon />
    //               </div>
    //               <div>
    //                 <p className="mb-3 text-base font-medium text-gray-50 dark:text-gray-100">
    //                   {title2 ? (
    //                     t(`${title2}`)
    //                   ) : (
    //                     <Skeleton count={1} height={20} />
    //                   )}
    //                 </p>
    //                 <p className="text-2xl font-bold leading-none text-gray-50 dark:text-gray-50">
    //                   {/* ${Math.round(price)} */}
    //                   {currency}
    //                   {price}
    //                 </p>
    //               </div>
    //               <div className="flex text-center text-xs font-normal text-gray-50 dark:text-gray-100">
    //                 <div className="px-1 mt-3">
    //                   {t("Cash")} : {currency}
    //                   {cash}
    //                 </div>
    //                 <div className="px-1 mt-3">
    //                   {t("Card")} : {currency}
    //                   {card}
    //                 </div>
    //                 <div className="px-1 mt-3">
    //                   {t("Credit")} : {currency}
    //                   {credit}
    //                 </div>
    //               </div>
    //             </div>
    //           </CardBody>
    //         </Card>
    //       ) : (
    //         <Card className="flex justify-center text-center h-full">
    //           <CardBody
    //             className={`border border-gray-200 dark:border-gray-800 w-full p-6 rounded-lg ${className}`}
    //           >
    //             <div
    //               className={`text-center inline-block text-3xl ${className}`}
    //             >
    //               <Icon />
    //             </div>
    //             <div>
    //               <p className="mb-3 text-base font-medium text-gray-50 dark:text-gray-100">
    //                 {t(`${title2}`)}
    //               </p>
    //               <p className="text-2xl font-bold leading-none text-gray-50 dark:text-gray-50">
    //                 {/* ${Math.round(price)} */}
    //                 {currency}
    //                 {price}
    //               </p>
    //             </div>
    //           </CardBody>
    //         </Card>
    //       )}
    //     </>
    //   )}
    // </>


    
  );
};

export default CardItemTwo;
